import type { RouteRecordRaw } from 'vue-router'

const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    component: () => import('@/layouts/auth/layout-auth.vue'),
    children: [
      {
        path: '',
        name: 'login',
        component: () => import('@/views/auth/page-login.vue'),
      },
      {
        path: 'lupa-password',
        name: 'forget password',
        component: () => import('@/views/auth/page-forgot-password.vue'),
      },
    ],
  },
]

export { authRoutes }
